import React from 'react';
import { IconProps } from '../DefaultIcon';

export function EvolveETTIcon({ className }: IconProps) {
  return (
    <svg
      width="89"
      height="79"
      viewBox="0 0 89 79"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_2839)">
        <path
          d="M83.7882 69.9609C84.0511 71.0158 84.3858 72.0468 84.8161 73.0538C84.5292 73.3655 84.2424 73.6532 83.9555 73.9409C83.1188 74.804 78.1704 75.6671 77.262 76.4583H17.068C15.9445 76.4583 14.8687 76.2905 13.8408 76.0028C11.8567 75.4514 10.0876 74.3724 8.67723 72.9579C6.7887 71.0638 5.54561 68.5463 5.25875 65.7172C5.21094 65.3336 5.21094 64.926 5.21094 64.5184C5.21094 57.9491 10.5179 52.6265 17.068 52.6265H86.5851C85.342 54.5925 84.4336 56.7263 83.8599 58.9081C83.5252 60.2028 83.31 61.5454 83.1905 62.8641C83.1188 63.8951 83.1188 64.926 83.1905 65.933C83.2861 67.2756 83.4774 68.5943 83.8121 69.889L83.7882 69.9609Z"
          fill="#EAF0F3"
        />
        <path
          d="M15.7776 72.9822C17.9291 75.1401 20.8934 76.4587 24.1684 76.4587H17.0446C13.7696 76.4587 10.8053 75.1161 8.65379 72.9822C6.5023 70.8484 5.1875 67.8514 5.1875 64.5668C5.1875 57.9974 10.4945 52.6748 17.0446 52.6748H24.1684C17.6183 52.6748 12.3113 57.9974 12.3113 64.5668C12.3113 67.8514 13.65 70.8244 15.7776 72.9822Z"
          fill="#DAE3E7"
        />
        <path
          d="M84.4583 39.4881C84.4583 41.7418 83.5499 43.7558 82.0917 45.2183C80.6334 46.6808 78.6015 47.5919 76.3783 47.5919H14.75C16.0887 45.4821 16.8537 43.1324 17.0449 40.7349C17.1645 39.4162 17.0927 38.0736 16.8537 36.7789C16.519 34.8848 15.8018 33.0387 14.75 31.3604H76.3544C80.8247 31.3604 84.4583 35.0047 84.4583 39.4881Z"
          fill="#EAF0F3"
        />
        <path
          d="M19.6745 47.6158H14.75C17.8816 42.6529 17.8816 36.3233 14.75 31.3843H19.6745C22.8061 36.3473 22.8061 42.6768 19.6745 47.6158Z"
          fill="#DAE3E7"
        />
        <path
          d="M14.8216 50.1332L47.835 54.9044L76.3781 50.1332C82.235 50.1332 86.9922 45.362 86.9922 39.488C86.9922 33.6139 82.235 28.8428 76.3781 28.8428H14.8216C13.4351 28.8428 12.3115 29.9696 12.3115 31.3602C12.3115 32.7508 13.4351 33.8777 14.8216 33.8777H76.3781C79.4619 33.8777 81.972 36.3951 81.972 39.488C81.972 42.5809 79.4619 45.0983 76.3781 45.0983H14.8216C13.4351 45.0983 12.3115 46.2252 12.3115 47.6158C12.3115 49.0064 13.4351 50.1332 14.8216 50.1332Z"
          fill="#00C4B3"
        />
        <path
          d="M12.3115 31.3842C12.3115 29.9936 13.4351 28.8667 14.8216 28.8667H20.9175C19.531 28.8667 18.4074 29.9936 18.4074 31.3842C18.4074 32.7747 19.531 33.9016 20.9175 33.9016H14.8216C13.4351 33.9016 12.3115 32.7747 12.3115 31.3842Z"
          fill="#00C4B3"
        />
        <path
          d="M20.9175 50.133H14.8216C13.4351 50.133 12.3115 49.0062 12.3115 47.6156C12.3115 46.225 13.4351 45.0981 14.8216 45.0981H20.9175C19.531 45.0981 18.4074 46.225 18.4074 47.6156C18.4074 49.0062 19.531 50.133 20.9175 50.133Z"
          fill="#00C4B3"
        />
        <path
          d="M88.9994 52.6747C88.9994 54.0653 87.8758 55.1922 86.4893 55.1922H17.0678C11.9043 55.1922 7.72081 59.4119 7.72081 64.5667C7.72081 69.7215 11.9043 73.9412 17.0678 73.9412H83.9553C82.1863 75.7633 80.2978 77.4416 78.2658 78.9761H17.0678C9.13123 78.9761 2.67676 72.5026 2.67676 64.5427C2.67676 63.5837 2.77238 62.6247 2.96362 61.7136C4.27842 55.1203 10.1114 50.1333 17.0678 50.1333H86.4893C87.8758 50.1333 88.9994 51.2602 88.9994 52.6507V52.6747Z"
          fill="#00416B"
        />
        <path
          d="M20.1282 79.0001H17.0444C9.10779 79.0001 2.65332 72.5266 2.65332 64.5667C2.65332 56.6067 9.10779 50.1333 17.0444 50.1333H20.1282C12.1916 50.1333 5.73712 56.6067 5.73712 64.5667C5.73712 72.5266 12.1916 79.0001 20.1282 79.0001Z"
          fill="#00416B"
        />
        <path
          d="M83.8366 58.9561C83.5019 60.2507 83.2868 61.5934 83.1673 62.912H30.3362C29.7864 62.912 29.3083 62.6963 28.9497 62.3366C28.5911 61.977 28.376 61.4735 28.376 60.946C28.376 59.8432 29.2605 58.9561 30.3601 58.9561H83.8605H83.8366Z"
          fill="#DAE3E7"
        />
        <path
          d="M64.401 38.7927C64.401 39.3442 64.1858 39.8237 63.8273 40.1833C63.4687 40.5429 62.9667 40.7587 62.4408 40.7587H17.0682C17.1877 39.4401 17.116 38.0974 16.877 36.8027H62.4408C63.5404 36.8027 64.4249 37.6898 64.4249 38.7927H64.401Z"
          fill="#DAE3E7"
        />
        <path
          d="M83.7884 69.9614H38.4876C37.9378 69.9614 37.4597 69.7456 37.1011 69.3859C36.7425 69.0263 36.5273 68.5228 36.5273 67.9954C36.5273 66.8925 37.4118 66.0054 38.5115 66.0054H83.1908C83.2864 67.348 83.4777 68.6667 83.8123 69.9614H83.7884Z"
          fill="#DAE3E7"
        />
        <path
          d="M81.1115 19.8041C81.3744 20.859 81.7091 21.89 82.1394 22.8969C81.8526 23.2086 81.5657 23.4963 81.2788 23.784C80.4421 24.6472 75.4937 25.5103 74.5853 26.3015H14.3914C13.2678 26.3015 12.1921 26.1337 11.1641 25.846C9.17998 25.2945 7.41097 24.2156 6.00055 22.801C4.11202 20.907 2.86894 18.3895 2.58207 15.5604C2.53426 15.1768 2.53426 14.7692 2.53426 14.3616C2.51035 7.86416 7.81737 2.51758 14.3914 2.51758H83.9084C82.6653 4.48359 81.7569 6.61743 81.1832 8.79922C80.8485 10.0939 80.6334 11.4365 80.5138 12.7552C80.4421 13.7862 80.4421 14.8171 80.5138 15.8241C80.6095 17.1667 80.8007 18.4854 81.1354 19.7801L81.1115 19.8041Z"
          fill="#EAF0F3"
        />
        <path
          d="M13.1009 22.849C15.2523 25.0068 18.2166 26.3255 21.4917 26.3255H14.3678C11.0928 26.3255 8.12852 24.9828 5.97703 22.849C3.82554 20.7151 2.51074 17.7182 2.51074 14.4335C2.51074 7.84019 7.84166 2.51758 14.3918 2.51758H21.5156C14.9655 2.51758 9.65847 7.84019 9.65847 14.4095C9.65847 17.6942 10.9972 20.6672 13.1248 22.825L13.1009 22.849Z"
          fill="#DAE3E7"
        />
        <path
          d="M86.3226 2.51745C86.3226 3.90804 85.199 5.0349 83.8125 5.0349H14.3911C9.2275 5.0349 5.04405 9.25463 5.04405 14.4094C5.04405 19.5642 9.2275 23.7839 14.3911 23.7839H81.2785C79.5095 25.6061 77.621 27.2844 75.5891 28.8188H14.3911C6.45447 28.8428 0 22.3693 0 14.4334C0 13.4504 0.0956218 12.5153 0.286865 11.5803C1.60167 4.98695 7.41069 0 14.3911 0H83.8125C85.199 0 86.3226 1.12686 86.3226 2.51745Z"
          fill="#00416B"
        />
        <path
          d="M17.4515 28.8428H14.3676C6.43104 28.8428 -0.0234375 22.3693 -0.0234375 14.4094C-0.0234375 6.44947 6.45494 0 14.3916 0H17.4754C9.53874 0 3.08427 6.47344 3.08427 14.4334C3.08427 22.3933 9.53874 28.8668 17.4754 28.8668L17.4515 28.8428Z"
          fill="#00416B"
        />
        <path
          d="M81.1599 8.79932C80.8252 10.094 80.61 11.4366 80.4905 12.7553H27.6595C27.1096 12.7553 26.6315 12.5395 26.2729 12.1799C25.9144 11.8203 25.6992 11.3168 25.6992 10.7893C25.6992 9.68642 26.5837 8.79932 27.6834 8.79932H81.1838H81.1599Z"
          fill="#DAE3E7"
        />
        <path
          d="M81.1117 19.8041H35.8108C35.261 19.8041 34.7829 19.5884 34.4243 19.2287C34.0657 18.8691 33.8506 18.3656 33.8506 17.8381C33.8506 16.7352 34.7351 15.8481 35.8347 15.8481H80.514C80.6097 17.1908 80.8009 18.5094 81.1356 19.8041H81.1117Z"
          fill="#DAE3E7"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_2839">
          <rect width="89" height="79" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
